import React from 'react';
import { FaEdit, FaExternalLinkAlt, FaChartLine } from 'react-icons/fa';
import fansidedLogo from '../assets/images/fansided-logo.svg';
import gemintLogo from '../assets/images/gemint-logo.svg';
import oregonSportsLogo from '../assets/images/oregon-sports-news-logo.svg';
import lwosLogo from '../assets/images/lwos-logo.svg';

const Experience = () => {
  const experiences = [
    {
      company: "Rip City Project, FanSided",
      title: "Content Strategist",
      period: "May 2024 - Present",
      type: "Content Marketing & Strategy",
      icon: <img src={fansidedLogo} alt="FanSided logo" className="company-logo" />,
      achievements: [
        "Manage content pipeline of 100+ articles monthly, coordinating editorial workflow and achieving 4K sessions per article",
        "Lead initiatives implementing SEO strategies and keyword optimization, driving 340K monthly organic traffic growth",
        "Coordinate content strategy and contributor management using Slack and Voltax CMS, resulting in 600K+ monthly sessions",
        "Analyze performance using Google Analytics, making data-driven optimizations to achieve top 10 ranking in NBA Division"
      ],
      skills: ["Content Strategy", "SEO Optimization", "Editorial Workflow", "Google Analytics", "Traffic Growth", "Team Leadership"],
      siteUrl: "https://ripcityproject.com/"
    },
    {
      company: "Oregon Sports News",
      title: "Sports Journalist",
      period: "Mar 2024 - Oct 2024",
      type: "Content Creation & Analytics",
      icon: <img src={oregonSportsLogo} alt="Oregon Sports News logo" className="company-logo" />,
      achievements: [
        "Created in-depth analysis of Pacific Northwest teams, primarily the Trail Blazers and Seahawks, boosting reader engagement",
        "Collaborated with editor-in-chief to develop data-driven content strategies, optimizing content for visibility and reach",
        "Implemented data-driven storytelling techniques on key storylines and performances to drive repeat site visits"
      ],
      skills: ["Content Creation", "Data-Driven Storytelling", "Content Strategy", "Sports Analytics", "Editorial Collaboration"],
      siteUrl: "https://oregonsportsnews.com/author/reese-kunz/"
    },
    {
      company: "Last Word On Sports",
      title: "Content Creator",
      period: "Mar 2023 - Oct 2023",
      type: "Content Marketing & SEO",
      icon: <img src={lwosLogo} alt="Last Word On Sports logo" className="company-logo" />,
      achievements: [
        "Created NBA articles focusing on the Phoenix Suns, leveraging analytics to enhance content, leading to a 50K surge in views",
        "Revamped 100+ articles, improving headlines, readability, and SEO, leading to higher engagement and search rankings",
        "Implemented advanced SEO strategies, resulting in monthly organic traffic of 43K"
      ],
      skills: ["Content Creation", "SEO Strategy", "Content Optimization", "Performance Analytics", "Traffic Growth"],
      siteUrl: "https://lastwordonsports.com/basketball/author/reesekunz/"
    },
    {
      company: "Rip City Project, FanSided",
      title: "Contributing Writer",
      period: "Mar 2023 - Oct 2023",
      type: "Content Creation & Growth",
      icon: <img src={fansidedLogo} alt="FanSided logo" className="company-logo" />,
      achievements: [
        "Researched and developed unique story angles on the Trail Blazers, contributing to a 50K increase in monthly site traffic",
        "Created SEO-optimized content via Voltax CMS and Google Analytics, using targeted keywords to boost organic search traffic",
        "Boosted site readership by 15K monthly through social media promotion and content planning in collaboration with the editor"
      ],
      skills: ["Content Research", "SEO Optimization", "Social Media Marketing", "Content Planning", "Analytics"],
      siteUrl: "https://ripcityproject.com/"
    },
    {
      company: "Gemint",
      title: "Product Manager",
      period: "Jan 2021 - Apr 2023",
      type: "Product Marketing & Development",
      icon: <img src={gemintLogo} alt="Gemint logo" className="company-logo" />,
      achievements: [
        "Led React-based web app development, managing cross-functional workflow to deliver custom features for 100+ users",
        "Enhanced product value proposition by prioritizing and delivering features such as Randomizers and Checklists",
        "Managed git workflow for contractors, ensuring code quality, minimizing conflicts, and setting development priorities"
      ],
      skills: ["Product Management", "Cross-functional Leadership", "Feature Development", "User Experience", "Team Coordination"],
      siteUrl: "https://www.gemint.com/"
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2 className="section-title">Experience</h2>

        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="experience-card">
              <div className="experience-header">
                <div className="experience-icon">{exp.icon}</div>
                <div className="experience-info">
                  <h3 className="experience-title">{exp.title}</h3>
                  <h4 className="experience-company">{exp.company}</h4>
                  <span className="experience-period">{exp.period}</span>
                  <span className="experience-type">{exp.type}</span>
                </div>
              </div>

              <div className="experience-content">
                <div className="achievements">
                  <h5>Key Achievements</h5>
                  <ul>
                    {exp.achievements.map((achievement, i) => (
                      <li key={i}>{achievement}</li>
                    ))}
                  </ul>
                </div>

                <div className="experience-skills">
                  <h5>Core Skills</h5>
                  <div className="skills-tags">
                    {exp.skills.map((skill, i) => (
                      <span key={i} className="skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>

                {exp.siteUrl && (
                  <div className="experience-link">
                    <a
                      href={exp.siteUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="site-link"
                    >
                      <FaExternalLinkAlt />
                      View Site
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;